import {EntityField} from "../../../core/genericdocuments/EntityField";
import {EntityFieldDataType} from "../../../core/genericdocuments/EntityFieldDataType";
import {EntityFieldsDescriptor} from "../../../core/genericdocuments/EntityFieldsDescriptor";
import {InvoiceDocument} from "./InvoiceDocument";
import {baseDocumentFields} from "../BaseDocumentFields";
import {Utility} from "../../../core/Utility";
import {LookupDataRow} from "../../../services/LookupDataRow";
import {LookupEntities} from "../../../core/genericdocuments/ReferenceDetails";

export const invoiceDocumentFields: IntercateKeysMap<InvoiceDocument, EntityField<InvoiceDocument>> = {
	...baseDocumentFields,
	clientId: {
		name: "clientId", dataType: EntityFieldDataType._reference, label: "Partner",
		referenceDetails: {
			lookupOptions: null,
			lookupEntity: LookupEntities.Customers
		},
		validator: { required: true },
		sortable: true,
		autocomplete: true
	},
	clientNumber: {
		name: "clientNumber", dataType: EntityFieldDataType._string, label: "Supplier invoice id",
		sortable: true,
		validator: { required: false }
	}
};

const invoiceDocumentFieldsArray: Array<EntityField<InvoiceDocument>> = [
	invoiceDocumentFields.indexingNumber,
	invoiceDocumentFields.indexingDate,
	invoiceDocumentFields.assignedTo,
	invoiceDocumentFields.tags,
	invoiceDocumentFields.clientId,
	invoiceDocumentFields.clientNumber
];

export const invoiceDocumentFieldsDescriptor: EntityFieldsDescriptor<InvoiceDocument> = {
	listFields: invoiceDocumentFieldsArray,
	createFormFields: invoiceDocumentFieldsArray,
	updateFormFields: invoiceDocumentFieldsArray
}
